import React from 'react';
import { Row, Col, Form, InputGroup } from 'react-bootstrap';
import { IconFileText } from '@tabler/icons-react';
import Select from 'react-select';
import TinyMCEEditor from '../TinyMCEEditor';

const Step3Content = ({ 
  formData, 
  register, 
  setValue, 
  errors, 
  saving 
}) => {
  // Opções de capacidades disponíveis
  const capabilitiesOptions = [
    { value: "Agendar consultas", label: "Agendar consultas" },
    { value: "Remarcar consultas", label: "Remarcar consultas" },
    { value: "Cancelar consultas", label: "Cancelar consultas" },
    { value: "Confirmar presença", label: "Confirmar presença" },
    { value: "Enviar lembretes", label: "Enviar lembretes" },
    { value: "Atender 24h", label: "Atender 24h" },
    { value: "Responder dúvidas gerais", label: "Responder dúvidas gerais" },
    { value: "Explicar serviços", label: "Explicar serviços" },
    { value: "Orientar pré atendimento", label: "Orientar pré atendimento" },
    { value: "Orientar pós atendimento", label: "Orientar pós atendimento" },
    { value: "Cadastrar clientes", label: "Cadastrar clientes" },
    { value: "Atualizar cadastro", label: "Atualizar cadastro" },
    { value: "Verificar horários disponíveis", label: "Verificar horários disponíveis" },
    { value: "Integrar com agenda externa", label: "Integrar com agenda externa" },
    { value: "Criar etiquetas internas", label: "Criar etiquetas internas" },
    { value: "Encaminhar casos para humanos", label: "Encaminhar casos para humanos" },
    { value: "Identificar urgências", label: "Identificar urgências" },
    { value: "Priorizar atendimentos", label: "Priorizar atendimentos" },
    { value: "Registrar histórico", label: "Registrar histórico" },
    { value: "Criar notas internas", label: "Criar notas internas" },
    { value: "Enviar documentos", label: "Enviar documentos" },
    { value: "Receber arquivos", label: "Receber arquivos" },
    { value: "Interpretar imagens", label: "Interpretar imagens" },
    { value: "Interpretar PDFs", label: "Interpretar PDFs" },
    { value: "Ajustar tom de voz", label: "Ajustar tom de voz" },
    { value: "Personalizar mensagens", label: "Personalizar mensagens" },
    { value: "Coletar feedback", label: "Coletar feedback" },
    { value: "Gerar relatórios simples", label: "Gerar relatórios simples" },
    { value: "Informar preços", label: "Informar preços" },
    { value: "Explicar pagamentos", label: "Explicar pagamentos" },
    { value: "Calcular valores", label: "Calcular valores" },
    { value: "Orientar sobre convênios", label: "Orientar sobre convênios" },
    { value: "Registrar preferências", label: "Registrar preferências" },
    { value: "Gerenciar fila de espera", label: "Gerenciar fila de espera" },
    { value: "Acompanhar clientes recorrentes", label: "Acompanhar clientes recorrentes" },
    { value: "Sugerir horários", label: "Sugerir horários" },
    { value: "Notificar atrasos", label: "Notificar atrasos" },
    { value: "Enviar aviso de retorno", label: "Enviar aviso de retorno" },
    { value: "Responder perguntas frequentes", label: "Responder perguntas frequentes" },
    { value: "Integrar com CRM", label: "Integrar com CRM" },
    { value: "Filtrar leads", label: "Filtrar leads" },
    { value: "Qualificar leads", label: "Qualificar leads" },
    { value: "Criar tags automáticas", label: "Criar tags automáticas" },
    { value: "Registrar origem do contato", label: "Registrar origem do contato" },
    { value: "Personalizar saudações", label: "Personalizar saudações" },
    { value: "Criar mensagens sazonais", label: "Criar mensagens sazonais" },
    { value: "Atender em múltiplos canais", label: "Atender em múltiplos canais" },
    { value: "Detectar intenção", label: "Detectar intenção" },
    { value: "Manter contexto", label: "Manter contexto" },
    { value: "Resumir conversas", label: "Resumir conversas" },
    { value: "Compartilhar links úteis", label: "Compartilhar links úteis" },
    { value: "Fornecer localização", label: "Fornecer localização" },
    { value: "Informar estacionamento", label: "Informar estacionamento" },
    { value: "Enviar instruções de chegada", label: "Enviar instruções de chegada" },
    { value: "Validar idade", label: "Validar idade" },
    { value: "Informar duração de serviços", label: "Informar duração de serviços" },
    { value: "Explicar etapas de processos", label: "Explicar etapas de processos" },
    { value: "Registrar alergias", label: "Registrar alergias" },
    { value: "Registrar medicações", label: "Registrar medicações" },
    { value: "Organizar agendamentos simultâneos", label: "Organizar agendamentos simultâneos" },
    { value: "Encerrar atendimento automaticamente", label: "Encerrar atendimento automaticamente" },
    { value: "Transferir para humano", label: "Transferir para humano" },
    { value: "Notificar equipe", label: "Notificar equipe" },
    { value: "Sugerir serviços", label: "Sugerir serviços" },
    { value: "Personalizar mensagens por horário", label: "Personalizar mensagens por horário" },
    { value: "Identificar humor do usuário", label: "Identificar humor do usuário" },
    { value: "Registrar preferências de comunicação", label: "Registrar preferências de comunicação" },
    { value: "Validar documentos enviados", label: "Validar documentos enviados" },
    { value: "Coletar dados para triagem", label: "Coletar dados para triagem" },
    { value: "Criar protocolos personalizados", label: "Criar protocolos personalizados" },
    { value: "Cumprir normas internas", label: "Cumprir normas internas" },
    { value: "Consultar políticas", label: "Consultar políticas" },
    { value: "Monitorar indicadores", label: "Monitorar indicadores" },
    { value: "Fazer triagem inicial", label: "Fazer triagem inicial" },
    { value: "Registrar motivo do contato", label: "Registrar motivo do contato" },
    { value: "Informar tempo de espera", label: "Informar tempo de espera" },
    { value: "Acompanhar solicitações abertas", label: "Acompanhar solicitações abertas" },
    { value: "Enviar checklists", label: "Enviar checklists" },
    { value: "Informar cuidados necessários", label: "Informar cuidados necessários" },
    { value: "Lembrar retornos", label: "Lembrar retornos" },
    { value: "Filtrar informações sensíveis", label: "Filtrar informações sensíveis" },
    { value: "Ajustar nível de formalidade", label: "Ajustar nível de formalidade" },
    { value: "Adaptar linguagem infantil", label: "Adaptar linguagem infantil" },
    { value: "Criar respostas rápidas", label: "Criar respostas rápidas" },
    { value: "Expandir respostas", label: "Expandir respostas" },
    { value: "Converter áudio em texto", label: "Converter áudio em texto" },
    { value: "Converter texto em áudio", label: "Converter texto em áudio" },
    { value: "Identificar spam", label: "Identificar spam" },
    { value: "Bloquear contatos", label: "Bloquear contatos" },
    { value: "Criar funis de atendimento", label: "Criar funis de atendimento" },
    { value: "Calcular parcelamentos", label: "Calcular parcelamentos" },
    { value: "Informar regras de cancelamento", label: "Informar regras de cancelamento" },
    { value: "Informar prazos", label: "Informar prazos" },
    { value: "Sugerir horários alternativos", label: "Sugerir horários alternativos" },
    { value: "Conectar sistemas internos", label: "Conectar sistemas internos" },
    { value: "Detectar clientes inativos", label: "Detectar clientes inativos" },
    { value: "Reengajar contatos", label: "Reengajar contatos" },
    { value: "Identificar dados incompletos", label: "Identificar dados incompletos" },
    { value: "Solicitar informações faltantes", label: "Solicitar informações faltantes" },
    { value: "Confirmar dados cadastrados", label: "Confirmar dados cadastrados" },
    { value: "Acompanhar solicitações pendentes", label: "Acompanhar solicitações pendentes" },
    { value: "Enviar protocolos", label: "Enviar protocolos" },
    { value: "Recuperar conversas antigas", label: "Recuperar conversas antigas" },
    { value: "Adaptar comunicação para idosos", label: "Adaptar comunicação para idosos" },
    { value: "Preencher formulários automaticamente", label: "Preencher formulários automaticamente" },
    { value: "Conduzir pesquisas de satisfação", label: "Conduzir pesquisas de satisfação" },
    { value: "Gerar mensagens de boas vindas", label: "Gerar mensagens de boas vindas" },
    { value: "Notificar sobre documentos faltantes", label: "Notificar sobre documentos faltantes" },
    { value: "Validar dados de contato", label: "Validar dados de contato" },
    { value: "Rastrear etapas de atendimento", label: "Rastrear etapas de atendimento" },
    { value: "Orientar sobre prazos internos", label: "Orientar sobre prazos internos" },
    { value: "Identificar dúvidas recorrentes", label: "Identificar dúvidas recorrentes" },
    { value: "Criar atalhos personalizados", label: "Criar atalhos personalizados" },
    { value: "Enviar comprovantes", label: "Enviar comprovantes" },
    { value: "Registrar consentimentos", label: "Registrar consentimentos" },
    { value: "Registrar autorizações", label: "Registrar autorizações" },
    { value: "Explicar políticas de privacidade", label: "Explicar políticas de privacidade" },
    { value: "Esclarecer termos de serviço", label: "Esclarecer termos de serviço" },
    { value: "Acompanhar processos internos", label: "Acompanhar processos internos" },
    { value: "Ajudar em pagamentos online", label: "Ajudar em pagamentos online" },
    { value: "Direcionar para formulários externos", label: "Direcionar para formulários externos" },
    { value: "Coletar informações de endereço", label: "Coletar informações de endereço" },
    { value: "Confirmar identidade por etapas", label: "Confirmar identidade por etapas" },
    { value: "Identificar tentativas suspeitas", label: "Identificar tentativas suspeitas" },
    { value: "Realizar triagem de urgência", label: "Realizar triagem de urgência" },
    { value: "Acompanhar tickets", label: "Acompanhar tickets" },
    { value: "Criar tickets automaticamente", label: "Criar tickets automaticamente" },
    { value: "Informar tempo médio de resposta", label: "Informar tempo médio de resposta" },
    { value: "Sinalizar prioridades", label: "Sinalizar prioridades" },
    { value: "Acompanhar fila interna", label: "Acompanhar fila interna" },
    { value: "Ajudar em assinaturas de contratos", label: "Ajudar em assinaturas de contratos" },
    { value: "Explicar etapas de assinatura digital", label: "Explicar etapas de assinatura digital" },
    { value: "Auxiliar em cadastros complexos", label: "Auxiliar em cadastros complexos" },
    { value: "Validar informações de agenda", label: "Validar informações de agenda" },
    { value: "Notificar horários incompatíveis", label: "Notificar horários incompatíveis" },
    { value: "Sugerir serviços complementares", label: "Sugerir serviços complementares" },
    { value: "Detectar insatisfação", label: "Detectar insatisfação" },
    { value: "Oferecer retorno humano imediato", label: "Oferecer retorno humano imediato" },
    { value: "Criar lembretes personalizados", label: "Criar lembretes personalizados" },
    { value: "Gerar relatórios de conversão", label: "Gerar relatórios de conversão" },
    { value: "Listar documentos necessários", label: "Listar documentos necessários" },
    { value: "Auxiliar em renovações", label: "Auxiliar em renovações" },
    { value: "Acompanhar solicitações de orçamento", label: "Acompanhar solicitações de orçamento" },
    { value: "Detalhar itens de orçamento", label: "Detalhar itens de orçamento" },
    { value: "Notificar alterações de preço", label: "Notificar alterações de preço" },
    { value: "Lembrar vencimentos", label: "Lembrar vencimentos" },
    { value: "Conduzir fluxos interativos", label: "Conduzir fluxos interativos" },
    { value: "Apresentar opções em lista", label: "Apresentar opções em lista" },
    { value: "Armazenar informações relevantes", label: "Armazenar informações relevantes" },
    { value: "Atuar com linguagem clara e objetiva", label: "Atuar com linguagem clara e objetiva" }
  ];

  const handleTagsChange = (value) => {
    const tags = value
      .split(",")
      .map((tag) => tag.trim())
      .filter((tag) => tag.length > 0);
    setValue("tags", tags);
  };

  const handleCapabilitiesChange = (selectedOptions) => {
    // Limitar a seleção a no máximo 15 capacidades
    if (selectedOptions && selectedOptions.length > 15) {
      return; // Não permite seleção além de 15 itens
    }
    
    // Extrair apenas os valores das opções selecionadas
    const capabilities = selectedOptions ? selectedOptions.map(option => option.value) : [];
    setValue("capabilities", capabilities);
  };

  // Converter capacidades atuais para formato do react-select
  const getSelectedCapabilities = () => {
    if (!formData.capabilities || !Array.isArray(formData.capabilities)) {
      return [];
    }
    return formData.capabilities.map(capability => ({
      value: capability,
      label: capability
    }));
  };

  return (
    <div className="mpf-step-content">
      <div className="mpf-step-header">
        <IconFileText size={24} className="text-primary" />
        <h4>Conteúdo</h4>
        <p className="text-muted">Descrição detalhada, tags e capacidades</p>
      </div>

      <TinyMCEEditor
        label="Descrição Completa *"
        value={formData.description}
        onChange={(value) => setValue("description", value)}
        error={errors.description?.message}
        disabled={saving}
        placeholder="Descrição detalhada do agente, suas funcionalidades e benefícios..."
        height={300}
      />

      <Row>
        {/*  <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Tags</Form.Label>
            <Form.Control
              type="text"
              value={(formData.tags || []).join(", ")}
              onChange={(e) => handleTagsChange(e.target.value)}
              placeholder="ia, automação, atendimento"
              disabled={saving}
            />
            <Form.Text className="text-muted">
              Separe as tags por vírgula
            </Form.Text>
          </Form.Group>
        </Col> */}

        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>URL do Vídeo Demonstrativo</Form.Label>
            <InputGroup>
              <InputGroup.Text>
                <i className="las la-video" />
              </InputGroup.Text>
              <Form.Control
                type="url"
                {...register("video_url")}
                placeholder="https://youtube.com/watch?v=..."
                disabled={saving}
              />
            </InputGroup>
            <Form.Text className="text-muted">
              URL do YouTube, Vimeo ou similar
            </Form.Text>
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Capacidades</Form.Label>
            <Select
              isMulti
              options={capabilitiesOptions}
              value={getSelectedCapabilities()}
              onChange={handleCapabilitiesChange}
              placeholder="Selecione as capacidades do agente..."
              isDisabled={saving}
              className="react-select-container"
              classNamePrefix="react-select"
              noOptionsMessage={() => "Nenhuma capacidade encontrada"}
              isSearchable={true}
              closeMenuOnSelect={false}
              blurInputOnSelect={false}
            />
            <Form.Text className="text-muted">
              Selecione até 15 capacidades que o agente possui ({getSelectedCapabilities().length}/15)
            </Form.Text>
          </Form.Group>
        </Col>
      </Row>
    </div>
  );
};

export default Step3Content;